export enum ShareAction {
    ViewShares = 'VIEW_SHARES'
};



// WEBPACK FOOTER //
// ./src/sharebase/components/shareDialog/shareDialog.actions.ts